
const watcher = new IntersectionObserver( setVisibility, {
    threshold: 0,
    rootMargin: '10px 0px',
} );

const callbacks = new Map();

function setVisibility( entries ) {
    entries.forEach( entry => {
        if ( entry.isIntersecting ) applyMouseFollow(entry.target);
        else removeMouseFollow(entry.target);
    })
}

function applyMouseFollow( element ) {
    window.addEventListener( 'mousemove', callbacks.get(element) );
}

function removeMouseFollow( element ) {
    window.removeEventListener( 'mousemove', callbacks.get(element) );
}

function setTransform( event, element ) {
    const center = [0.5 * element.offsetWidth, 0.5 * element.offsetHeight];
    const cap = '1.5';
    const vicinity = 0.5 * element.offsetWidth;
    const mouse = [event.clientX, event.y];
    const diff = [mouse[0] - center[0], mouse[1] - center[1]];
    const distance = Math.sqrt( diff[0] ** 2 + diff[1] ** 2 );
    const unit = [1 / distance * diff[0], 1 / distance * diff[1]];
    const amount = Math.max( Math.min( distance / vicinity * cap, cap ), -cap );
    const translate = [unit[0] * amount, unit[1] * amount];

    element.style.setProperty( '--translate', `${translate[0]}%, ${translate[1]}%` );
}

export function mouseFollowWhenVisible( element ) {
    callbacks.set( element, (e) => {
        setTransform( e, element );
    })
    watcher.observe( element );
}